// src/api_scripts/getbusinesshoursList.js
import { fetchAllPages } from "../paginationUtils";

const getBusinessHours = async (businesshoursListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/business-hours`;

  try {
    // Use the pagination utility to fetch all pages
    const businesshoursListsArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Business Hours");
    console.log("Get Business Hours List API Response Data (all pages):", businesshoursListsArray.length, "items");
    return businesshoursListsArray;

  } catch (error) {
    console.error(`Error fetching Business Hours:`, error);
    throw error; // Re-throw the error to be caught by the calling function
  }
};

export default getBusinessHours;
